/**
 * PCM Fancybox Legacy Links
 *
 * Auto-initializes Fancybox on any `[data-fancybox]` link left over from
 * migrated content that doesn't already get Fancybox wired up elsewhere.
 * Skips the site search modal toggle, which has its own handling.
 */
(function($) {
  'use strict';

  function initFancyboxLinks() {
    if (!$.fn.fancybox) {
      return;
    }

    $('[data-fancybox]').not('.pcm-search-modal-toggle').each(function() {
      const $link = $(this);

      if ($link.data('pcmLegacyFancybox')) {
        return;
      }

      $link.data('pcmLegacyFancybox', true);
      $link.fancybox();
    });
  }

  if ($ && $.fn) {
    $(initFancyboxLinks);
  }
})(window.jQuery);
